export enum DashboardSection {
  RecentRecipes = 'recentRecipes',
  SharedWithMe = 'sharedWithMe',
  WorkspaceFiles = 'workspaceFiles',
  SharedApps = 'sharedApps',
}
